import { useQuery } from 'react-query';

import type { RecommendCategoryItemRequest } from '~/api/data-source/recommend';
import { RECOMMEND_QUERY_KEY } from '~/api/query-keys';

export type { MarketProductItem } from '~/api/model';

/** 홈 - 구매한 상품의 연관상품 추천 */
// GET /api/market-place/v1/recommend/home-category-items
export const useHomeCategoryRecommendItems = () => {
  const { queryKey, queryFn } = RECOMMEND_QUERY_KEY.homeCategoryItems();

  return useQuery(queryKey, queryFn, {
    suspense: true,
    keepPreviousData: true,
  });
};

/** 분류 기반 연관상품 추천 (offerIds 기반) */
// GET /api/market-place/v1/recommend/category-items
export const useCategoryRecommendItems = (
  request: RecommendCategoryItemRequest,
) => {
  const { queryKey, queryFn } = RECOMMEND_QUERY_KEY.categoryItems(request);

  return useQuery(queryKey, queryFn, {
    suspense: true,
    keepPreviousData: true,
  });
};

/** 업종별 인기상품 추천 */
// GET /api/market-place/v1/recommend/classification-items
export const useClassificationRecommendItems = () => {
  const { queryKey, queryFn } = RECOMMEND_QUERY_KEY.classificationItems();

  return useQuery(queryKey, queryFn, {
    suspense: true,
    keepPreviousData: true,
  });
};
